import { ChangeDetectionStrategy, Component } from '@angular/core';
// eslint-disable-next-line @tseslint/no-unused-vars
import { TableDataService } from '@core/services/table/table-data.service';
// eslint-disable-next-line @tseslint/no-unused-vars
import { OverviewHeaderComponent } from '../../overview-header.component';

/**
 * Add this Component to {@link OverviewHeaderComponent | app-overview-header} to add a Searchbar that automatically sets a Fulltext-Filter in the {@link TableDataService}
 *
 * @example
 *
 * ```html
 * <app-overview-header>
 *   <!-- other overview-header child-components... -->
 *   <app-overview-header-search/>
 *   <!-- other overview-header child-components... -->
 * </app-overview-header>
 * ```
 */
@Component({
  selector: 'app-overview-header-search',
  standalone: true,
  imports: [],
  templateUrl: './overview-header-search.component.html',
  styleUrl: './overview-header-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class OverviewHeaderSearchComponent {}
